import { render, staticRenderFns } from "./TransferWpPosts.vue?vue&type=template&id=232d2b30&"
import script from "./TransferWpPosts.vue?vue&type=script&lang=js&"
export * from "./TransferWpPosts.vue?vue&type=script&lang=js&"
import style0 from "./TransferWpPosts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports